import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "handle"]
  static values = { url: String }

  connect() {
    this.dragItem = null
    this.setupDragAndDrop()
  }

  setupDragAndDrop() {
    const items = this.listTarget.querySelectorAll("li")
    items.forEach(item => {
      item.setAttribute("draggable", "true")
      item.addEventListener("dragstart", this.handleDragStart.bind(this))
      item.addEventListener("dragover", this.handleDragOver.bind(this))
      item.addEventListener("dragend", this.handleDragEnd.bind(this))
      item.addEventListener("drop", this.handleDrop.bind(this))
    })
  }

  handleDragStart(e) {
    this.dragItem = e.currentTarget
    e.currentTarget.classList.add("opacity-50")
    e.dataTransfer.effectAllowed = "move"
  }

  handleDragOver(e) {
    e.preventDefault()
    e.dataTransfer.dropEffect = "move"

    const target = e.currentTarget
    if (target !== this.dragItem && target.tagName === "LI") {
      const rect = target.getBoundingClientRect()
      const midY = rect.top + rect.height / 2
      if (e.clientY < midY) {
        this.listTarget.insertBefore(this.dragItem, target)
      } else {
        this.listTarget.insertBefore(this.dragItem, target.nextSibling)
      }
    }
  }

  handleDrop(e) {
    e.preventDefault()
  }

  handleDragEnd(e) {
    e.currentTarget.classList.remove("opacity-50")
    this.saveOrder()
  }

  async saveOrder() {
    const items = this.listTarget.querySelectorAll("li")
    const categoryIds = Array.from(items).map(item => item.dataset.categoryId)

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ category_ids: categoryIds })
      })
    } catch (error) {
      console.error("Failed to save category order:", error)
    }
  }
}
